import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Select from 'react-select';

import { APIHandler, StorageHandler } from 'C4';
import { contentKeys, storageKeys, language } from 'settings';

import countryFlags from './countryFlags';

const CountryFlag = ({ flag }) => {
  const Flag = (flag && countryFlags[flag.toUpperCase()]
    ? countryFlags[flag.toUpperCase()]
    : countryFlags.EN);

  return (<Flag />);
};

const changeLanguage = (e) => {
  const { value, label } = e;
  const [file] = language
    .filter(({ code: c, mainCode }) => c.includes(value) || (mainCode && mainCode.includes(value)))
    .map(({ langFile }) => langFile);
  StorageHandler.removeKeys(contentKeys);
  StorageHandler.remove(storageKeys.progress);
  StorageHandler.save(storageKeys.lang, {
    country: label,
    code: value,
    langFile: file,
  });
  window.location.reload();
};

export default class LanguageSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      languages: [],
      selected: '',
      expand: false,
    };

    this.loadLanguages = this.loadLanguages.bind(this);
  }

  componentDidMount() {
    this.loadLanguages();
    StorageHandler.load(storageKeys.lang).then(({ code, country }) => {
      const activeCountry = { value: code, label: country };
      this.setState({ selected: activeCountry });
    });
  }

  focusHandler() {
    this.setState(prevState => ({ expand: !prevState.expand }));
  }

  async loadLanguages() {
    const availableCountries = language.map(({ countries }) => countries.map(country => country)).flat();
    const availableLanguages = language.map(({ code }) => code.map(c => c.toLowerCase())).flat();

    const codes = language.map(({ code, countries, mainCode }) => {
      if (countries.length >= 1) {
        if (code.length === 1) return code[0];
        if (countries.length > 1 && code.length > 1) return code;
        if (code.length > 1) return mainCode;
      }
      return `xx_${Date.now()}`;
    }).flat();

    const lang = await StorageHandler.load(storageKeys.lang);
    if (!lang) {
      const location = await APIHandler.getLocation();

      if (!location.countryCode) {
        StorageHandler.save(storageKeys.lang, { country: 'United_States', code: 'en', langFile: 'en' });
        return;
      }

      const code = location.countryCode.toLowerCase();

      const [file] = language.filter(({ code: c }) => c.includes(code)).map(({ langFile }) => langFile);
      const [country] = language
        .filter(({ code: c }) => c.includes(code))
        .map(({ countries, code: c }) => countries[c.indexOf(code)] || countries[0]);

      if (location && availableLanguages.includes(code)) {
        let countryCode = location.countryCode.toLowerCase();
        StorageHandler.save(storageKeys.lang, { country, code: countryCode, langFile: file });
        this.loadLanguages();
      } else if (!await StorageHandler.exists(storageKeys.lang)) {
        StorageHandler.save(storageKeys.lang, { country: 'United_States', code: 'en', langFile: 'en' });
      }
    }

    const countryList = availableCountries.map((country, i) => ({
      value: codes[i],
      label: country,
    }));

    const activeCountry = { value: lang.code, label: lang.country };
    this.setState({ languages: countryList, selected: activeCountry });
  }

  render() {
    const { size, ...selectProps } = this.props;
    const { selected, languages, expand } = this.state;

    // Context meant for differentiating between current selection and dropdown options
    const formatOptionLabel = ({ value, label }) => (
      <p className="customOption">
        <CountryFlag flag={value} />
        {label ? label.replace(/[_]/g, ' ') : 'Error loading languages'}
      </p>
    );

    return (
      <div className={`lang__select ${expand ? 'active' : ''}`} style={{ flex: (expand ? size * 2 : size), maxWidth: expand && 'unset' }}>
        <Select
          value={selected}
          options={languages}
          onChange={changeLanguage}
          formatOptionLabel={formatOptionLabel}
          onFocus={() => this.focusHandler()}
          onBlur={() => this.focusHandler()}
          {...selectProps}
          menuPlacement="top"
        />
      </div>
    );
  }
}

LanguageSelect.propTypes = {
  menuPlacement: PropTypes.string,
  size: PropTypes.number,
};

LanguageSelect.defaultProps = {
  menuPlacement: 'bottom',
  size: 2,
};


CountryFlag.propTypes = {
  flag: PropTypes.string,
};

CountryFlag.defaultProps = {
  flag: null,
};
